import {Card, Form} from "react-bootstrap";
import noPhoto from "../../../common/image/no photo stub.jpg"
import {useEffect, useRef, useState} from "react";
import styles from './CatalogProductNew.module.css'
import {useCartContext} from "../../../Context/CartContext";
import "./../../../common/Layout/modal.css"
import {Button} from "primereact/button";
import "primeicons/primeicons.css";
import {Dialog} from "primereact/dialog";
import useDiscount from "../../Hooks/useDiscount";
import {useWindowDimensions} from "../../../Context/WindowDimensionsContext";
import {Tooltip} from "primereact/tooltip";
import {ProductCardNew} from "../ProductCard/ProductCardNew";
import {toNumber} from "lodash";
import {ProductBalance} from "../../../common/constants"
import {LubematchProductCard} from "../../Lubematch/LubematchProductCard/LubematchProductCard";

export const CatalogProductNew = ({
                                   id,
                                   name,
                                   number,
                                   articleList,
                                   recommendPrice,
                                   priceList,
                                   balance,
                                   deliveryDate,
                                   smallImageUrls,
                                   isDiscount,
                                   countInCart,
                                   toast,
                                   lubematchCard = false
                               }) => {

    const [isHovered, setIsHovered] = useState(false);
    const [itemPriceIndex, setItemPriceIndex] = useState(0)
    const [prices, setPrices] = useState([]);
    const [recommendPriceVue, setRecommendPriceVue] = useState('');
    const [productCount, setProductCount] = useState(1);
    const [profit, setProfit] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);

    //balance
    const [productBalanceStatus, setProductBalanceStatus] = useState(ProductBalance.InStock)

    //
    const [count, setCount] = useState(countInCart)
    const [isLoading, setIsLoading] = useState(false)
    const timerRef = useRef(null);


    //discount
    const {discountModel, getDiscountModel} = useDiscount();
    const [discountTooltip, setDiscountTooltip] = useState(``)
    const [discountPersent, setDiscountPersent] = useState("");
    const [isDiscountLabelHovered, setIsDiscountLabelHovered] = useState(false);
    const divRef = useRef(null);
    const presentTooltipRef = useRef(null);

    const [presentDiv, setPresentDiv] = useState(<div></div>);
    const [productButton, setProductButton] = useState(<Button/>)
    const {cart, addToCart, addProductToBaseOrder, updateBaseOrderItem, deleteBaseOrderItem} = useCartContext();

    const {viewPortWidth,viewPortHeight} = useWindowDimensions();

    const [show, setShow] = useState(false);


    const [old, setOld] = useState(0);

    //modal info
    const handleClose = () => {
        setShow(false);

    }

    //discount
    useEffect(() => {
        const model = getDiscountModel();
        if(model){
            setDiscountTooltip(`При наборі ${model.DiscountCondition}л Ви отримаете дисконт ${model.DiscountPercent}% на всі товари з цією поміткою.`)
            setDiscountPersent("-" + model.DiscountPercent +"%");
        }
    },[discountModel] )


    const handleMouseEnterDiscountLabel = () => {
        setIsDiscountLabelHovered(true);
    };

    const handleMouseLeaveDiscountLabel = () => {
        setIsDiscountLabelHovered(false);
    };

    const handleShow = () => setShow(true);

    const addToCartHandler = () => {

        addProductToBaseOrder({
            id: id,
            name: name,
            priceList: priceList,
            number: number,
            isDiscount: isDiscount,
            recommendPrice: recommendPrice,
            priceListIndex: itemPriceIndex,
            count: productCount,
            calcPrice: totalAmount
        }).then((data) => {
            if (data.isSucccess) {
                toast.current.clear();
                toast.current.show({
                    severity: 'success',
                    summary: 'Додано у кошик',
                    clearPrevious: true,
                    detail: name + '' + ' (' + productCount + 'шт)',
                    life: 900,
                });

            } else {
                toast.current.clear();
                toast.current.show({
                    severity: 'error',
                    summary: 'Помилка',
                    clearPrevious: true,
                    detail: 'Помилка змінення кошика',
                    life: 1000
                });
            }
        })
    }

    const cleanString = (inputStr) => {
        // Убираем все пробелы
        let noSpaces = inputStr.replace(/\s+/g, '');

        // Убираем все вхождения "шт"
        let noShT =  noSpaces.replace(/шт/g, '');

        // Если строка заканчивается на "ш", удаляем последний и предпоследний символы
        if (noShT.endsWith('ш')) {
            noShT = noShT.slice(0, -2);
        }
        return noShT;
    }
    const countHandler = (e) => {
        e.target.value = cleanString(e.target.value);
        if (e.target.value === "" || toNumber(e.target.value) === 0) {
            toast.current.clear();
            setCount(1)
        } else if (e.target.validity.valid && !(e.target.value === "" || e.target.value === undefined || isNaN(e.target.value))) {
            setCount(parseFloat(e.target.value))
        }
    }
    const countHandleClick = (e) => {
        e.target.select();
    }

    useEffect(() => {
        let tooltip = '';
        let icon = '';
        let color = '';
        let status = null;
        let prodButton = (<Button label="В кошик" style={{height:'100%', width:'100%', fontFamily:'Commissioner', fontWeight:'500', color:'#666666' }}  onClick={add} className={styles.buyButton}/>)
    
        // Определяем статус и параметры иконки и кнопки на основе balance и даты поставки
        if (balance === 0) {
            status = ProductBalance.OutOfStock;
            tooltip = 'Немає в наявності';
            icon = 'pi pi-clock';
            color = '#dc3545';
            if(deliveryDate){
                prodButton = (<div style={{fontSize:"1rem", fontWeight:'600'}}>Очікуємо поставки</div>)
            }else{
                prodButton = (<div style={{fontSize:"1rem", fontWeight:'600'}}>Немає в наявності</div>)
            }
        } else if (balance >= 6) {
            status = ProductBalance.Ends;
            tooltip = 'В наявності';
            icon = 'pi pi-verified';
            color = '#28a745';
        } else if (balance < 6) {
            status = ProductBalance.InStock;
            tooltip = 'Закінчується';
            icon = 'pi pi-clock';
            color = '#ff9800';
        }
    
        // Определяем стиль в зависимости от ширины
        const style = viewPortWidth > 700
            ? { fontSize: '20px', color, float: 'right', zIndex: 100 }
            : { fontSize: '22px', color, textAlign: 'center', alignSelf: 'center', zIndex: 100 };
    
        setProductBalanceStatus(status);
        setPresentDiv(<i className={`present-icon ${icon}`} ref={presentTooltipRef} data-pr-tooltip={tooltip} style={style}></i>);
        setProductButton(prodButton)

    }, [balance, viewPortWidth]);

    const deleteProductFromCart = () => {
        setIsLoading(true)
        if(count <= 0){
            deleteBaseOrderItem(id).then((data) => {
                // setTimeout(() => {
                //     setIsLoading(false);
                // },100)
                setIsLoading(false);
                if (data.isSucccess) {
                    console.log('Cart updated')
                } else {
                    toast.current.clear();
                    toast.current.show({
                        severity: 'error',
                        summary: 'Помилка оновлення кошика',
                        detail: data.message,
                        life: 1000
                    });
                }
            })
        }
    }

    const updateCart = () => {
        setIsLoading(true)
        updateBaseOrderItem({
            id: id,
            count: count,
        }).then((data) => {
            // setTimeout(() => {
            //     setIsLoading(false);
            // },100)
            setIsLoading(false);
            if (data.isSucccess) {
                console.log('Cart updated')
            } else {
                toast.current.clear();
                toast.current.show({
                    severity: 'error',
                    summary: 'Помилка оновлення кошика',
                    detail: data.message,
                    life: 1000
                });
            }
        })
    }

    const add = () => {
        setCount(1);
    }
    const incrementCount = () => {
        setCount(count + 1);
    }

    const decrementCount = () => {
        setCount(count - 1)
    }

    useEffect(() => {
        if(countInCart !== count){
            setCount(countInCart)
        }
    },[countInCart])

    useEffect(() => {
        // Очищаем таймер, если он уже был запущен
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        if(count === 1 && countInCart === 0) {
            addToCartHandler();
        }
        else if (count >= 1 && countInCart !==0) {
            // Запускаем таймер на 700 миллисекунд
            timerRef.current = setTimeout(() => {
                updateCart();
            }, 700);
        }
        else if(count <= 0 && countInCart > 0){
            deleteProductFromCart();
        }

        // Очищаем таймер при размонтировании компонента
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    },[count])

    useEffect(() => {
        if (recommendPrice === 0) {
            setRecommendPriceVue('');
        } else {
            setRecommendPriceVue(recommendPrice);
        }
    }, [recommendPrice])

    useEffect(() => {
        if (priceList.length !== 0) {
            setPrices(priceList);
        }
    }, [priceList]);

    useEffect(() => {
        //если стереть число, чтобы не ломалось
        if (productCount === "" || productCount === undefined || isNaN(productCount)) {
            setProductCount(0);
            setTotalAmount(0)
        }
        //калькуляция общей цены этого продукта по количеству
        setOld(parseFloat(totalAmount));
        if (productCount || productCount === "0") {
            //общая сумма
            setTotalAmount(parseFloat((priceList[itemPriceIndex].UoMPrice * parseFloat(productCount))).toFixed(2))
            //прибыль
            if (recommendPrice !== 0) {
                setProfit(((parseFloat(recommendPrice) * productCount) - parseFloat((priceList[itemPriceIndex].UoMPrice * parseFloat(productCount)))).toFixed(2))
            }
        }
    }, [productCount, itemPriceIndex]);

    useEffect(() => {
        //калькуляция общей цены всех продуктов
        if (recommendPrice !== 0) {
            setProfit(((parseFloat(recommendPrice) * productCount) - parseFloat((priceList[itemPriceIndex].UoMPrice * parseFloat(productCount)))).toFixed(2))
        }
    }, [totalAmount]);

    if (priceList.length === 0) {
        return (<div></div>)
    }


    if(lubematchCard){
        return (
            <LubematchProductCard 
                id={id}
                name={name}
                number={number}
                count={count}
                decrementCount={decrementCount}
                incrementCount={incrementCount}
                countHandler={countHandler}
                countHandleClick={countHandleClick}
                articleList={articleList}
                recommendPrice={recommendPrice}
                priceList={priceList}
                balance={balance}
                deliveryDate={deliveryDate}
                smallImageUrls={smallImageUrls}
                isDiscount={isDiscount}
                countInCart={countInCart}
                toast={toast}
                productBalanceStatus={productBalanceStatus}
                presentTooltipRef={presentTooltipRef}
                presentDiv={presentDiv}
                discountTooltip={discountTooltip}
                discountPersent={discountPersent}
                isDiscountLabelHovered={isDiscountLabelHovered}
                handleMouseEnterDiscountLabel={handleMouseEnterDiscountLabel}
                handleMouseLeaveDiscountLabel={handleMouseLeaveDiscountLabel}
                setIsHovered={setIsHovered}
                divRef={divRef}
                handleShow={handleShow}
                viewPortHeight={viewPortHeight}
                viewPortWidth={viewPortWidth}
                itemPriceIndex={itemPriceIndex}
                productButton={productButton}
                show={show}
                setShow={setShow}
                add={add}
                totalAmount={totalAmount}
            />
        )
    }

    return (
        <div  className={`${styles.cardWrapper} ${productBalanceStatus === ProductBalance.OutOfStock  && styles.opacity05}` }>
            <Tooltip target={presentTooltipRef} content={discountTooltip} position='top' />
            <span className={styles.number_present} >{number} {presentDiv}</span>
            {articleList?.length ? <span className={styles.article} >{articleList[0]} </span> : null}
            {isDiscount ? <div style={{position:'relative'}}>
                <Tooltip target={divRef} content={discountTooltip} position='top' />
                <div ref={divRef} className={`${isDiscountLabelHovered ? 'discountLabel' : ''} ${styles.discountLabel}`} onMouseEnter={handleMouseEnterDiscountLabel}
                     onMouseLeave={handleMouseLeaveDiscountLabel}  >{discountPersent}</div>
            </div>: null}

            <Card className={`${styles.card} catalog-product-card-body`} onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}>
                {smallImageUrls.length ? 
                <Card.Img onClick={handleShow} variant="top" className={styles.cardImage} src={smallImageUrls[0]} />
                :
                <Card.Img onClick={handleShow} variant="top" className={styles.cardImage} src={noPhoto}  />
                }

                <Card.Body className={styles.cardBody}>
                    <Card.Title className={styles.cardTitleName} >{name}</Card.Title>

                    <div>
                        {viewPortWidth > 700 ?
                            <div className={styles.priceWrapper}>
                                <div className={styles.price}>{priceList[itemPriceIndex].UoMPrice.toLocaleString('uk-UA', {
                                    style: 'currency',
                                    currency: 'UAH',
                                    currencyDisplay: 'symbol'
                                })}</div>
                                <div className={styles.rrcWrapper}>
                                    <div style={{ paddingBottom: '5px' }}>
                                        <span  >РРЦ</span>: {recommendPrice.toLocaleString('uk-UA', {
                                        style: 'currency',
                                        currency: 'UAH',
                                        currencyDisplay: 'symbol'
                                        }
                                        )}
                                    </div>
                                </div>
                            </div>
                        :
                         <div style={{display:'grid', gridTemplateColumns:'3fr 135px', gap: '5px'}}>
                             <div className={styles.priceWrapper}>
                                 <div>
                                     <div className={styles.price}>{priceList[itemPriceIndex].UoMPrice.toLocaleString('uk-UA', {
                                         style: 'currency',
                                         currency: 'UAH',
                                         currencyDisplay: 'symbol'
                                     })}</div>
                                     <div className={styles.rrcWrapper}>
                                         <div style={{ paddingBottom: '5px' }}>
                                             <span  >РРЦ</span>: {recommendPrice.toLocaleString('uk-UA', {
                                                 style: 'currency',
                                                 currency: 'UAH',
                                                 currencyDisplay: 'symbol'
                                             }
                                         )}
                                         </div>
                                     </div>
                                 </div>
                             </div>
                             <div className={styles.cardAdditional}>

                                 {countInCart === 0 ?
                                     <div style={{height:'45px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                                         {productButton}
                                     </div>
                                     :
                                     <div className={`${styles.btnShadow} p-inputgroup  productCountInput`} style={{height: '45px', position:"relative"}}>
                                         <span className={styles.productCountInputLabel}>У кошику:</span>
                                         <Button className={styles.changeCountButton} icon={`pi ${count <= 1 ? 'pi-trash' : 'pi-minus' }`} rounded text raised onClick={decrementCount}
                                                 style={{borderRadius: '10px 0px 0px 10px', height: '100%', width:'40%', color:'#666666', background:'#fbce07', boxShadow:"none"}}/>
                                         <Form.Control style={{textAlign: 'center', height: '100%', borderRadius:0, fontSize:'1.3rem'}} type="text" min={0} pattern="[0-9]*"
                                                       onClick={countHandleClick} onInput={countHandler}
                                                       value={count > 0 ? count + ' шт': 1 + ' шт'}/>
                                         <Button className={styles.changeCountButton} icon="pi pi-plus"  rounded text raised onClick={incrementCount}
                                                 style={{borderRadius: '0px 10px 10px 0px', height: '100%', width:'40%', color:'#666666', background:'#fbce07',  boxShadow:"none"}}/>
                                     </div>
                                 }

                             </div>
                         </div>
                        }
                        <div className={styles.cardBtnWrapper}>
                            {viewPortWidth > 700 ?
                                <div className={styles.cardAdditional}>

                                    {countInCart === 0 ?
                                        <div style={{height:'45px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                                            {productButton}
                                            {viewPortWidth <= 700 && presentDiv}
                                        </div>
                                        :
                                        <div className={`${styles.btnShadow} p-inputgroup  productCountInput`} style={{height: '45px', position:"relative"}}>
                                            <span className={styles.productCountInputLabel}>У кошику:</span>
                                            <Button className={styles.changeCountButton} icon={`pi ${count <= 1 ? 'pi-trash' : 'pi-minus' }`} rounded text raised onClick={decrementCount}
                                                    style={{borderRadius: '10px 0px 0px 10px', height: '100%', width:'25%', color:'#666666', background:'#fbce07', boxShadow:"none"}}/>
                                            <Form.Control style={{textAlign: 'center', height: '100%', borderRadius:0, fontSize:'1.1rem'}} type="text" min={0} pattern="[0-9]*"
                                                           onClick={countHandleClick} onInput={countHandler}
                                                           value={count > 0 ? count + ' шт': 1 + ' шт'}/>
                                            <Button className={styles.changeCountButton} icon="pi pi-plus"  rounded text raised onClick={incrementCount}
                                                    style={{borderRadius: '0px 10px 10px 0px', height: '100%', width:'25%', color:'#666666', background:'#fbce07',  boxShadow:"none"}}/>
                                        </div>
                                    }

                                </div>
                            : null}

                        </div>
                    </div>
                </Card.Body>
            </Card>

            <div className={`${styles.modalBody}`}>

                <Dialog header={name} maximizable modal={true} visible={show} className="productCardModal"
                        style={{backgroundColor: '#e0e0e0', width: '90%', height: '90vh', color: '#495057'}}
                        onHide={() => setShow(false)}>
                    <ProductCardNew
                        id={id}
                        articleList={articleList}
                        number={number}
                        addToCart={add}
                        setShow={setShow}
                        price={totalAmount}
                        balance={balance}
                        deliveryDate={deliveryDate}
                    />
                </Dialog>
            </div>
        </div>
    )
}